import { ArrowRightIcon } from '@langchain/untitled-ui-icons';

import { Button, Text } from '@/design-system';

import { STARTUP_FORM_URL } from '../utils/constants';

export const StartupApplyBanner = () => {
  return (
    <div className="flex w-full items-center gap-1.5 rounded-xl bg-tertiary px-6 py-4">
      <Text variant="xs" weight="semibold">
        Small team getting started with building agents?
      </Text>
      <Text variant="xs" weight="normal">
        Accelerate your growth with LangSmith for Startups.
      </Text>
      <a
        href={STARTUP_FORM_URL}
        target="_blank"
        className="flex flex-row gap-1"
      >
        <Button
          variant="underlined"
          color="secondary"
          className="bg-transparent"
          rightDecorator={ArrowRightIcon}
        >
          Apply Now
        </Button>
      </a>
    </div>
  );
};
